<template>
  <div class="login_footer">
    <div class="language_list">
      <router-link
        :to="$route.path + '?langcode=EN'"
        class="language_link"
        :class="language == 'EN' ? 'active' : ''"
        :disabled="language == 'EN'"
        >English</router-link
      >&nbsp;|
      <router-link
        :to="$route.path + '?langcode=ZH'"
        class="language_link"
        :class="language == 'ZH' ? 'active' : ''"
        :disabled="language == 'ZH'"
        >简体中文</router-link
      >&nbsp;|
      <router-link
        :to="$route.path + '?langcode=ZHT'"
        class="language_link"
        :class="language == 'ZHT' ? 'active' : ''"
        :disabled="language == 'ZHT'"
        >繁體中文</router-link
      >
    </div>
    <div class="links_list">
      <router-link to="" class="links_link">{{ pageText.about }}</router-link
      >&nbsp;|
      <router-link to="" class="links_link">{{ pageText.contact }}</router-link
      >&nbsp;|
      <router-link to="" class="links_link">{{
        pageText.recruitment
      }}</router-link
      >&nbsp;|
      <router-link to="" class="links_link">{{
        pageText.merchantssettled
      }}</router-link
      >&nbsp;|
      <router-link to="" class="links_link">{{
        pageText.adservice
      }}</router-link
      >&nbsp;|
      <router-link to="" class="links_link">{{ pageText.links }}</router-link
      >&nbsp;|
      <router-link to="" class="links_link">{{
        pageText.saleSalliance
      }}</router-link
      >&nbsp;|
      <router-link to="" class="links_link">English Site</router-link>
    </div>
    <div class="copyright_info">
      <span
        >COPYRIGHT&nbsp;&nbsp; © 2010-2021&nbsp;&nbsp;SAMEX Systems
        Limited.&nbsp;&nbsp;</span
      >
      <span>{{ pageText.copyRight }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: ["language"],
  data() {
    return {
      pageText: {
        about: this.$t("common_pageText.ABOUTUS"),
        contact: this.$t("common_pageText.CONTACTUS"),
        recruitment: this.$t("common_pageText.RECRUITMENT"),
        merchantssettled: this.$t("common_pageText.MERCHANTSSETTLED"),
        adservice: this.$t("common_pageText.ADSERVICE"),
        links: this.$t("common_pageText.LINKS"),
        saleSalliance: this.$t("common_pageText.SALESALLIANCE"),
        copyRight: this.$t("common_pageText.COPYRIGHT")
      }
    };
  },
  watch: {
    "$i18n.locale"(curVal, oldVal) {
      this.pageText.about = this.$t("common_pageText.ABOUTUS");
      this.pageText.contact = this.$t("common_pageText.CONTACTUS");
      this.pageText.recruitment = this.$t("common_pageText.RECRUITMENT");
      this.pageText.merchantssettled = this.$t(
        "common_pageText.MERCHANTSSETTLED"
      );
      this.pageText.adservice = this.$t("common_pageText.ADSERVICE");
      this.pageText.links = this.$t("common_pageText.LINKS");
      this.pageText.saleSalliance = this.$t("common_pageText.SALESALLIANCE");
      this.pageText.copyRight = this.$t("common_pageText.COPYRIGHT");
    }
  }
};
</script>

<style scoped>
.login_link {
  color: #ffa000;
  display: inline-block;
  margin-left: 5px;
}
.login_footer {
  width: 100%;
  height: 150px;
  color: #9b9ea0;
  background-color: #313131;
  text-align: center;
  overflow: hidden;
}
.language_list {
  display: block;
  margin-top: 21px;
}
.language_link {
  display: inline-block;
  color: #9b9ea0;
  font-weight: lighter;
}
.language_link:hover,
.language_link.active {
  color: #a50606;
  font-weight: 700;
}
.links_list {
  margin-top: 10px;
}
.links_link {
  display: inline-block;
  color: #9b9ea0;
  font-weight: lighter;
  margin: 0 10px;
}
.links_link:hover {
  color: #a50606;
}
.copyright_info {
  margin-top: 10px;
}
</style>
